import React, { useEffect } from 'react';
import { TrendingUp, TrendingDown, X, Copy, Check } from 'react-feather';
import useDeposit from '@hooks/useDeposit';
import useWithdraw from '@hooks/useWithdraw';
import useWallet from '@hooks/useWallet';
import { useTradeHistory } from '@hooks/useTrade';
import { WalletTable } from '../components';
import { LoaderContext } from '../../../App';
import { LoaderOverlay } from '@components';
import { useUserStore } from '../../../models'

const WalletModal = ({ closeModal }) => {
  const {
    address,
    copied,
    copy,
    amount,
    handleAmountChange,
    hash,
    handleHashChange,
    handleFileChange,
    deposit,
    proof,
    loading,
  } = useDeposit({ closeModal: closeModal });
  const { setLoading } = React.useContext(LoaderContext);
  React.useEffect(() => {
    setLoading(loading);
  }, [loading]);

  return (
    <section
      className="wallet_modal_wrapper"
      onClick={(e) => {
        e.stopPropagation();
        closeModal();
      }}
    >
      {loading && <LoaderOverlay />}
      <div className="wallet_modal" onClick={(e) => e.stopPropagation()}>
        <div className="wallet_modal_header">
          <h1 className="wallet_modal_title">Deposit to your wallet</h1>
          <X className="wallet_modal_close" onClick={closeModal} />
        </div>
        <div className="wallet_modal_body">
          <p className="wallet_modal_description">
            To deposit funds to your wallet, send the desired USD amount to one
            of the addresses below.
          </p>
          <div
            className="addresses_container"
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              //   overflowX: "scroll",
              gap: '1rem',
            }}
          >
            {address?.map((_a, index) => (
              <div
                className={`address_container ${copied[index] && 'copied'}`}
                onClick={() => copy(index)}
              >
                <img
                  src={
                    _a.network === 'BTC'
                      ? '/wallets/btc.svg'
                      : _a.network === 'USDT TRC20'
                        ? '/wallets/usdt-trc20.svg'
                        : _a.network === 'ETH'
                          ? '/wallets/eth.svg'
                          : '/wallets/usdt.svg'
                  }
                  alt="Blockchain logo"
                  width={20}
                  height={20}
                />
                <p className="address" onClick={() => copy(index)}>
                  {copied[index]
                    ? 'Copied to clipboard'
                    : _a?.hash?.length > 20 && window.innerWidth <= 900
                      ? _a?.hash?.slice(0, 20) + '...'
                      : _a?.hash}
                </p>
                {copied[index] ? (
                  <Check className="copied" />
                ) : (
                  <Copy className="copy" onClick={() => copy(index)} />
                )}
              </div>
            ))}
          </div>
          <p className="wallet_modal_description">
            To confirm your deposit, please attach a screenshot of the
            transaction.
          </p>
          <input
            type="file"
            name="proof"
            id="proof"
            className="file_input"
            onChange={handleFileChange}
          />
          <input
            type="number"
            name="amount"
            id="amount"
            className="text_input"
            placeholder="Enter the desired amount (in USD)"
            onChange={handleAmountChange}
          />
          {/* <input
            type="text"
            name="hash"
            id="hash"
            className="text_input"
            placeholder="Enter transaction hash"
            value={hash}
            onChange={handleHashChange}
          /> */}
          <p className="wallet_modal_description">
            Please note that it may take up to 2 hours for your deposit to be
            reflected in your wallet.
          </p>
        </div>
        <button
          className={`modal_submit ${
            (!amount || !proof) && 'disabled_button'
          }`}
          onClick={deposit}
          disabled={!proof || !amount}
        >
          Confirm Deposit
        </button>
      </div>
    </section>
  );
};

const Withdraw = ({ closeModal, balance }) => {
  const {
    amount,
    address,
    handleAmountChange,
    handleAddressChange,
    withdraw,
    loading,
    error,
  } = useWithdraw({ closeModal: closeModal });
  const { setLoading } = React.useContext(LoaderContext);
  React.useEffect(() => {
    setLoading(loading);
  }, [loading]);
  
  return (
    <section
      className="wallet_modal_wrapper"
      onClick={(e) => {
        e.stopPropagation();
        closeModal();
      }}
    >
      {loading && <LoaderOverlay />}
      <div className="wallet_modal" onClick={(e) => e.stopPropagation()}>
        <div className="wallet_modal_header">
          <h1 className="wallet_modal_title">Withdraw from your wallet</h1>
          <X className="wallet_modal_close" onClick={closeModal} />
        </div>
        <div className="wallet_modal_body">
          <p className="wallet_modal_description">
            To withdraw funds from your wallet, enter the desired amount and the
            address to which you want to send the funds.
          </p>
          <h3>Your balance: ${balance ? balance : '0.00'}</h3>
          <input
            type="number"
            name="amount"
            id="amount"
            className={`text_input ${error && 'input_error'}`}
            placeholder="Enter the desired amount (in USD)"
            onChange={(e) => handleAmountChange(e, balance)}
          />
          {error && <p className="error_message">{error}</p>}
          <input
            type="text"
            name="address"
            id="address"
            className="text_input"
            placeholder="Enter the wallet address"
            value={address}
            onChange={handleAddressChange}
          />
          <p className="wallet_modal_description">
            Please note that it may take up to 2 hours for your withdrawal to be
            reflected in your wallet.
          </p>
        </div>
        <button
          className={`modal_submit ${
            (amount === '' || address === '' || error) && 'disabled_button'
          }`}
          onClick={() => {
            if (amount === '' || address === '' || error) return;
            withdraw();
          }}
          disabled={amount === '' || address === '' || error}
        >
          Confirm Withdrawal
        </button>
      </div>
    </section>
  );
};

const Wallet = () => {
  const { user } = useUserStore();
  const { setLoading } = React.useContext(LoaderContext);

  const { wallets } = useWallet();
  useEffect(() => {

  }, [wallets]);
  const [modal, setModal] = React.useState(null);

  const openCloseModal = (mode = null) => {
    if (modal === mode) setModal(null);
    else setModal(mode);
  };
  return (
    <div className="wallet_container" style={modal && { height: '100dvh' }}>
      {/* {loading && <LoaderOverlay />} */}
      {modal === 'deposit' && (
        <WalletModal closeModal={() => openCloseModal(null)} />
      )}
      {modal === 'withdraw' && (
        <Withdraw
          closeModal={() => openCloseModal(null)}
          balance={user?.totalBalance?.toFixed(2)}
        />
      )}

      <div className="header">
        <div className="header_meta">
          <p className="title">
            Total balance: ${user?.totalBalance?.toFixed(2) || 0} 
          </p>
          {/* <p className="title">Total holdings: ${total?.toFixed(2)}</p> */}
        </div>
        <div className="header_cta">
          <button
            className="header_button"
            onClick={() => openCloseModal('deposit')}
          >
            Deposit
          </button>
          <button
            className="header_button"
            onClick={() => openCloseModal('withdraw')}
          >
            Withdraw
          </button>
        </div>
      </div>
      <div className="flex flex-col xl:flex-row w-full gap-8">
        <WalletTable
          title="Deposits"
          descriptionNoItms="You haven't made any deposits yet"
          deposits={wallets.deposits}
        />
        <WalletTable
          title="Withdraws"
          descriptionNoItms="You haven't made any withdraws yet"
          deposits={wallets.withdraws}
        />
      </div>
    </div>
  );
};

export default Wallet;
